import { apiInterfaceForJson } from '../common/apiManager';
import { serviceConstants } from '../common/constants';
import { getUserAuthToken } from '../common/util';

// Search/list legacy patients
export const searchLegacyPatients = (query = '', page = 1, limit = 25, sortField = 'lastName', sortOrder = 'asc') => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    params.append('page', page);
    params.append('limit', limit);
    params.append('sortField', sortField);
    params.append('sortOrder', sortOrder);
    return apiInterfaceForJson(`/legacy-viewer/v1/patients?${params.toString()}`, 'GET');
};

// Get single legacy patient with all details
export const getLegacyPatient = (id) => {
    return apiInterfaceForJson(`/legacy-viewer/v1/patients/${id}`, 'GET');
};

// Get dashboard stats (patient count, requisition count, PDF count)
export const getLegacyStats = () => {
    return apiInterfaceForJson('/legacy-viewer/v1/stats', 'GET');
};

// Construct URL for a legacy PDF (opens in browser with auth)
export const getLegacyPdfUrl = (filePath) => {
    const token = getUserAuthToken();
    return `${serviceConstants.API_HOST_NAME}/legacy-viewer/v1/pdf/${encodeURI(filePath)}?token=${token}`;
};
